export function formatGenerationMetrics(
  generationMs: number | null | undefined,
  outputTokens: number,
): string | null {
  if (generationMs == null || generationMs <= 0) return null;
  const generationSeconds = generationMs / 1000;
  const secondsLabel = `${generationSeconds.toFixed(1)}s`;
  if (outputTokens <= 0) return secondsLabel;
  const throughput = (outputTokens / Math.max(generationSeconds, 0.001)).toFixed(1);
  return `${secondsLabel} · ${throughput} tok/s`;
}
